import { render, staticRenderFns } from "./DoiSearch.vue?vue&type=template&id=502b6860&scoped=true"
import script from "./DoiSearch.vue?vue&type=script&lang=js"
export * from "./DoiSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b6860",
  null
  
)

export default component.exports